export default __webpack_public_path__ + "static/media/poly.a8b1843b.gif";